import styled from 'styled-components';

interface ModalProps {
  visible: boolean;
}

export const Modal = styled.div<ModalProps>`
  display: flex;
  flex-direction: column;
  background: white;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  overflow: hidden;
  width: 100%;
  transform-origin: top right;
  opacity: ${(props) => (props.visible ? '1' : '0')};
  transform: ${(props) => (props.visible ? 'scale(1)' : 'scale(0)')};
  transition-property: opacity, transform;
  transition-duration: 200ms;
  transition-timing-function: ease-out;
`;

export const ModalHeader = styled.div`
  padding: 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

interface ClearFilterButtonProps {
  isActive: boolean;
}

export const ClearFilterButton = styled.div<ClearFilterButtonProps>`
  color: ${(props) => (props.isActive ? '#2b6ed2' : '#a5adb5')};
  line-height: 24px;
  margin-right: 28px;
  font-size: 16px;
  font-weight: bold;
`;

export const CloseButton = styled.span`
  font-size: 32px;
  line-height: 1;
`;

export const ModalBody = styled.div`
  padding: 16px;
  flex-grow: 1;
`;

export const PropertyInputWrapper = styled.div`
  margin-bottom: 24px;
`;

export const PriceInputWrapper = styled.div``;

export const ModalFooter = styled.div`
  padding: 16px;
  box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.2);
`;

export const FooterButton = styled.div`
  padding: 10px;
  background: #0081c6;
  border-radius: 3px;
  width: 100%;
  color: #ffffff;
  text-align: center;
  font-size: 18px;
`;
